var exports = {
  "m": "Octicon__YwGxad",
};

module.exports = exports;
